import { useFormik } from "formik";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import AscSelectInput from "../AscInputFields/AscSelectInput/AscSelectInput";
import AscDateInput from "../AscInputFields/AscDateInput/AscDateInput";
import { AdminCalendarIcon, AdminChevronDownIcon } from "../AscIcons";
import classNames from "classnames";
import styles from "./AscActionBar.module.scss";
import { If } from "react-conditional-components-renderer";

export interface AscActionBarProps {
  className?: string;
  header?: string | null;
  children: React.ReactNode;
  onlySelectData?: boolean;
  optionContainerClassName?: string;
  onRangeData?: (dates: [string, string]) => any;
}

export const batchArray = [
  { label: "Year 9", value: "year9" },
  { label: "Year 10", value: "year10" },
  { label: "Year 11", value: "year11" },
];

export const studentName = [
  { label: "Frederic", value: "frederic" },
  { label: "James", value: "james" },
  { label: "John", value: "john" },
];

export default function AscActionBar({
  className,
  header,
  children,
  onlySelectData,
  optionContainerClassName,
  onRangeData,
}: AscActionBarProps) {
  const formik = useFormik({
    initialValues: {
      batch: "",
      studentName: [],
      date: "",
    },
    onSubmit: (values) => console.log("values: ", values),
  });


  return (
    <div
      data-testid="asc-action-bar"
      className={classNames(styles.ground, className)}
    >
      {!onlySelectData && (
        <div className={styles.leftGround}>
          {header && (
            <AscHeading className={styles.header} level={6}>
              {header}
            </AscHeading>
          )}

          <form className={styles.inputGround}>
            <AscSelectInput
              className={styles.input}
              fullWidth={true}
              id="batch"
              name="batch"
              placeholder="All students"
              arrowIcon={<AdminChevronDownIcon />}
              // onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.batch}
              inputWrapperClassName={styles.inputWrapper}
              selectedOptionClassName={styles.inputOption}
              optionContainerClassName={classNames(
                styles.optionContainerClassName,
                optionContainerClassName
              )}
            >
              {batchArray.map((batch) => (
                <AscSelectInput.Option
                  key={batch.value}
                  value={batch.value}
                  label={batch.label}
                />
              ))}
            </AscSelectInput>

            <AscSelectInput
              className={styles.input}
              multiple
              id="studentName"
              name="studentName"
              placeholder="Student name"
              arrowIcon={<AdminChevronDownIcon />}
              //onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.studentName}
              inputWrapperClassName={styles.inputWrapper}
              multipleOptionSelectionDisplayClassName={
                styles.multipleOptionSelectionDisplay
              }
              optionsTagClassName={styles.optionsTag}
              hidden
              selectedOptionClassName={styles.inputOption}
              optionContainerClassName={classNames(
                styles.optionContainerClassName,
                optionContainerClassName
              )}
            >
              {studentName.map((student) => (
                <AscSelectInput.Option
                  key={student.value}
                  value={student.value}
                  label={student.label}
                />
              ))}
            </AscSelectInput>

            <AscDateInput
              className={classNames(styles.dateInput)}
              id="date"
              name="date"
              placeholder="9 June 2022 - 10 June 2022"
              size="medium"
              disabled={false}
              range={true}
              arrowIcon={<AdminCalendarIcon className={styles.icon} />}
              dateIcon={null}
            />
          </form>
        </div>
      )}

      <If test={onlySelectData === true}>
        <AscDateInput
          className={classNames(styles.dateInput)}
          id="date"
          name="date"
          placeholder="9 June 2022 - 10 June 2022"
          size="medium"
          disabled={false}
          range={true}
          arrowIcon={<AdminCalendarIcon className={styles.icon} />}
          dateIcon={null}
          onChange={onRangeData}
        />
      </If>

      <div className={styles.rightGround}>{children}</div>
    </div>
  );
}
